import { useFlags, useLDClient } from "launchdarkly-react-client-sdk";
import { useEffect, useState } from "react";

import Actions from "../Actions";
import logger from "../utils/LoggerFrontend";

/**
 * Custom React hook for managing Launch Darkly context based on organization loading.
 *
 * @returns Launch Darkly flags.
 */
function useLDContext() {
  const flags = useFlags();
  const client = useLDClient();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadOrganizationCompletedHandler = async (organization) => {
      logger.log("useLDContext:Mount", "init", {
        isLoading
      });

      if (!isLoading) {
        const namespace = "useLDContext:Actions.loadOrganization.completed";
        const { user } = window;
        setIsLoading(true);

        logger.log(namespace, "organization loaded", {
          userId: user?.uid,
          orgaId: organization?.id
        });

        if (!user || !organization?.id) {
          return;
        }

        const context = {
          kind: "multi",
          user: {
            key: user.uid,
            name: user.displayName,
            email: user.email,
            createdDate: user.metadata.creationTime,
            isUsingNewRole: user.isUsingNewRole || false,
            rolesMigrationGroup: user.rolesMigrationGroup || "default"
          },
          organization: {
            key: organization.id,
            name: organization.name,
            createdDate: organization.createdDate,
            isAgency: organization.isAgency,
            companySize: organization.companySize,
            isUsingNewRole: organization.isUsingNewRole || false,
            rolesMigrationGroup: organization.rolesMigrationGroup || "default"
          }
        };

        logger.log(namespace, "context ready to send to Launch Darkly", context);

        try {
          await client.identify(context);
          logger.log(`${namespace}:identify`, "context sent to Launch Darkly", context);
        } catch (error) {
          logger.log(`${namespace}:Error identifying with Launch Darkly:`, error);
        }

        setIsLoading(false);
      }
    };

    // Call completed listener
    Actions.loadOrganization.completed.listen(loadOrganizationCompletedHandler);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return flags;
}

export default useLDContext;
